import { formAnatomy as parts } from "@chakra-ui/anatomy";
import type { PartsStyleObject, SystemStyleObject } from "@chakra-ui/theme-tools";

const baseStyleRequiredIndicator: SystemStyleObject = {
    // By default we're not showing indicator, but styling is here for checkout where it's used.
    display: "none",
    color: "inherit",
    order: "-1",
    marginInlineStart: 0,
    marginInlineEnd: 1,
};

const baseStyleHelperText: SystemStyleObject = {
    pt: 2,
    mt: 0,
    color: "black",
    fontSize: "mobileBodyB4",
    lineHeight: "normal",
    letterSpacing: "normal",
};

const baseStyle: PartsStyleObject<typeof parts> = {
    container: { width: "100%", position: "relative", alignItems: "flex-end" },
    requiredIndicator: baseStyleRequiredIndicator,
    helperText: baseStyleHelperText,
};

export const formStyles = {
    parts: parts.keys,
    baseStyle,
};
